<template>
	<div class="knowledgebase">
		<div class="topbagdiv">
			<div class="logodiv">
				<img src="../assets/images/logo.png" />
			</div>
			<div class="titlediv">
				<div class="usertitle">药王知识库</div>
			</div>
			<div class="backdiv">
				<back></back>
			</div>
		</div>
		<div class="bcc">
			<a href="javascript:void(0);" class="wzzl" @click="$router.back()">
				<p>返回</p>
			</a>
			<div class="context">
				文章专栏
			</div>
			<div class="knowledgebaseitem1">
				<!-- <div class="pagediv">
					<span class="pagediv_left">{{name}}</span>
					<template v-if="pages>1">
						<a href="javascript:void(0);" class="pagebtn mr sy" @click="sy"><span>首页</span></a>
						<a href="javascript:void(0);" class="pagebtn mr syy" @click="syy"><span>上一页</span></a>
						<a href="javascript:void(0);" class="pagenum mr btnb" v-if="pageslist!=null"
							with-v-for="index in pageslist" @click="clickpagenum(index)" :data-id="index" :key="index"><span>{{index}}</span></a>
						<a href="javascript:void(0);" class="pagebtn mr xyy" @click="xyy"><span>下一页</span></a>
						<a href="javascript:void(0);" class="pagebtn wy" @click="wy"><span>尾页</span></a>
					</template>
				</div> -->
				<div class="toptitle">
					<div class="toptitleleft">
						<img src="../assets/images/usertxt.png" />文章名称
					</div>
					<div class="toptitleright">
						<img src="../assets/images/zzz.png" />作者
					</div>
					<div class="toptitleright">
						<img src="../assets/images/usersj.png" />发布时间
					</div>
					<div class="toptitleright" style="width: 20%;">
						<img src="../assets/images/ccc.png" />浏览次数
					</div>
				</div>
				<div class="zskbox">
					<a href="javascript:void(0);" v-for="item in list" :key="item.id" @click="incontent(item.id)">
						<div class="zskitem">
							<div class="zskitemleft">
								{{item.title}}
							</div>
							<div class="zskitemright">
								{{item.creator}}
							</div>
							<div class="zskitemright">
								{{setData(item.createdAt)}}
							</div>
							<div class="zskitemright" style="width: 20%;">
								{{item.click}}
							</div>
						</div>
					</a>
				</div>
				<div class="pagediv center mt" v-if="pages>1">
					<!-- pageactive -->
					<a href="javascript:void(0);" class="pagebtn mr sy" @click="sy"><span>首页</span></a>
					<a href="javascript:void(0);" class="pagebtn mr syy" @click="syy"><span>上一页</span></a>
					<a href="javascript:void(0);" class="pagenum mr btnb" v-if="pageslist!=null"
						with-v-for="index in pageslist" @click="clickpagenum(index)"
						:data-id="index"><span>{{index}}</span></a>
					<a href="javascript:void(0);" class="pagebtn mr xyy" @click="xyy"><span>下一页</span></a>
					<a href="javascript:void(0);" class="pagebtn wy" @click="wy"><span>尾页</span></a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import back from '../components/backhome/back.vue'
	import axios from 'axios'

	export default {
		name: 'Knowledgebase',
		components: {
			back,
		},
		data() {
			return {
				token: this.$store.state.token, //token
				userid: this.$store.state.userid, //id
				type: '',
				classlist: [],
				classid: null,
				list: [],
				pageNum: 1,
				pageSize: 20, //20条一页
				pages: 0, //总页数
				pageslist: null,
				name: "全部",
			}
		},
		created() {
			this.gettxtlist()
		},
		mounted() {

		},
		methods: {
			mess() {
				this.$router.push({
					path: '/personal',
					query: {
						type: 'messagereply'
					}
				})
			},
			xxlist() {
				this.$router.push({
					path: '/personal',
					query: {
						type: 'learningrecords'
					}
				})
			},
			clickpagenum(index) {
				if (index != this.pageNum) {
					this.pageNum = index
					this.gettxtlist()
				}
			},
			// select(el, id, classname) {
			// 	let alist = document.getElementById('classbox').children
			// 	for (let i = 0; i < alist.length; i++) {
			// 		alist[i].className = ''
			// 	}
			// 	this.classid = id
			// 	this.pageNum = 1
			// 	this.name = classname
			// 	if (this.classid === id) {
			// 		el.target.className = 'ccactive'
			// 	}
			// 	this.gettxtlist()
			// },
			gettxtlist() {
				new Promise((resolve, reject) => {
					axios({
						url: this.$api.commonUrl + 'posts',
						type: 'GET',
						params: {
							"pageNum": this.pageNum,
							"pageSize": this.pageSize,
							"categoryId": "13",
							"type": "1"
						},
						headers: {
							"Authorization": "Bearer " + this.token
						}
					}).then(res => {
						if (res.data.code == '200') {
							this.list = res.data.data.list
							this.pages = res.data.data.pages
							if (parseInt(res.data.data.pages) >= 5) {
								for (let i = 1; i <= 5; i++) {
									if (this.pageNum > 2) {
										this.pageslist = [this.pageNum - 2, this.pageNum - 1, this.pageNum,
											this
											.pageNum + 1, this.pageNum + 2
										]
									}
									if (this.pageNum <= 2) {
										this.pageslist = [1, 2, 3, 4, 5]
									}
									if (this.pageNum >= this.pages - 2) {
										this.pageslist = [this.pages - 4, this.pages - 3, this.pages - 2,
											this.pages -
											1, this.pages
										]
									}
								}
							} else if (parseInt(res.data.data.pages) < 5) {
								let newlist = []
								for (let i = 1; i <= parseInt(res.data.data.pages); i++) {
									newlist.push(i)
								}
								this.pageslist = newlist
							}
							resolve()
						} else {
							console.log(re.data.message)
						}
					}).catch(err => {
						console.log(err)
					})
				}).then((res) => {
					this.pushclass()
				})
			},
			// getclasslist() {
			// 	axios({
			// 		url: this.$api.commonUrl + 'knowledge/points/type',
			// 		method: 'GET',
			// 		headers: {
			// 			"Authorization": "Bearer " + this.token
			// 		}
			// 	}).then(res => {
			// 		if (res.data.code == '200') {
			// 			this.classlist = res.data.data
			// 		}
			// 	}).catch(err => {
			// 		console.log(err)
			// 	})
			// },
			pushclass() {
				let allpageelement = document.getElementsByClassName('btnb')
				for (let i = 0; i < allpageelement.length; i++) {
					if (parseInt(allpageelement[i].getAttribute('data-id')) === this.pageNum) {
						allpageelement[i].className = 'pagenum mr btnb pageactive'
					} else {
						allpageelement[i].className = 'pagenum mr btnb'
					}
				}
			},
			sy() {
				if (this.pageNum != 1) {
					this.pageNum = 1
					this.gettxtlist()
				}
			},
			syy() {
				if (this.pageNum > 1) {
					this.pageNum -= 1
					this.gettxtlist()
				}
			},
			xyy() {
				if (this.pageNum < this.pages) {
					this.pageNum += 1
					this.gettxtlist()
				}
			},
			wy() {
				if (this.pageNum != this.pages) {
					this.pageNum = this.pages
					this.gettxtlist()
				}
			},
			setData(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '年' + MM + '月' + d + '日 ' + h + ':' + m + ':' + s
			},
			incontent(id) {
				this.$router.push({
					path: "/knowledgebasedetails2",
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.knowledgebase {
		background: #f3ede3;
	}

	.wzzl p {
		width: 100%;
		height: 100%;
		position: absolute;
		line-height: 7.5rem;
	}

	.wzzl {
		position: absolute;
		top: 7.78rem;
		right: calc((100% - 80rem) / 2 - 8rem);
		width: 7.5rem;
		height: 7.5rem;
		background: url(../assets/images/select1.png) no-repeat;
		background-size: 100% 100%;
		margin-bottom: 1rem;
		color: #a2693f;
		line-height: calc(7.5rem / 3);
		font-size: 1.857142rem;
		font-family: 'STXingkai' !important;
		text-align: center;
		text-decoration: none;
	}

	.context {
		height: 4.28rem;
		background: url(../assets/images/zsktopbag.png) no-repeat;
		background-size: 100% 100%;
		margin-top: 1rem;
		width: 100%;
		text-align: center;
		line-height: 4.28rem;
		color: #FFFFFF;
		font-size: 1.428rem;
	}

	.knowledgebase .bcc {
		position: absolute;
		left: 0px;
		right: 0px;
		top: 6rem;
		bottom: 0px;
		overflow-y: auto;
		background: #f3ede3 url(../assets/images/zskbag.png) no-repeat;
		background-size: 100%;
		z-index: 2;
		width: 80rem;
		padding-left: calc((100% - 80rem) / 2);
		padding-right: calc((100% - 80rem) / 2);
	}

	.knowledgebase .bcc::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.knowledgebase .bcc::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}

	/*滚动条里面轨道*/
	.knowledgebase .bcc::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}

	.knowledgebase .contextleft {
		display: flex;
	}

	.knowledgebase .contextleft,
	.knowledgebase .contextright {
		width: 50%;
	}

	.knowledgebase .contextleft a {
		display: block;
		width: 8.6rem;
		height: 3.28rem;
		background: url(../assets/images/zskwxz.png) no-repeat;
		background-size: 100% 100%;
		margin: 0.5rem;
		line-height: 3.28rem;
		text-align: center;
		font-size: 1.428rem;
		color: #fffef4;
		text-decoration: none;
	}

	.knowledgebase .contextright {
		text-align: right;
	}

	.knowledgebase .contextright a {
		display: inline-block;
		height: 3.28rem;
		margin: 0.5rem;
		line-height: 3.28rem;
		color: #7b4d2b;
		font-size: 1.428rem;
		text-decoration: none;
	}

	.knowledgebase .contextright a:last-child {
		margin-right: 1.5rem;
	}

	/* 
	.knowledgebase .contextright a:last-child {
		margin-right: 1rem;
	} */

	.knowledgebase .contextleft .ccactive {
		background: url(../assets/images/zskxz.png) no-repeat;
		background-size: 100% 100%;
		font-weight: bold;
	}

	.knowledgebase .topbagdiv {
		background: url(../assets/images/usertopbag.png);
		background-size: 100% auto;
		height: 6rem;
		display: flex;
		z-index: 2;
		box-shadow: 0px 0px 10px #efdcc9;
	}

	.knowledgebase .logodiv,
	.knowledgebase .backdiv {
		width: 25rem;
		height: 6rem;
	}

	.knowledgebase .titlediv {
		width: calc(100% - 50rem);
		height: 6rem;
		position: relative;
	}

	.knowledgebase .logodiv img {
		width: 16rem;
		height: 4.03rem;
		margin: calc(1.97rem / 2);
	}

	.knowledgebase .titlediv {
		text-align: center;
		height: 6rem;
	}

	.knowledgebase .usertitle {
		background: url(../assets/images/usertitlebag.png) no-repeat;
		background-size: 100% 100%;
		width: 25rem;
		height: 4rem;
		line-height: 4.5rem;
		font-size: 2rem;
		font-family: 'STXingkai';
		color: #783d1a;
		position: absolute;
		margin: auto;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
	}

	.knowledgebase .back .backimg {
		right: 1rem;
		top: 1rem;
	}

	.knowledgebaseitem1 .pageactive {
		background: #b7886c !important;
	}

	.knowledgebaseitem1 .mt {
		margin-bottom: 2rem;
		margin-top: 2rem;
	}

	.knowledgebaseitem1 .pageactive span {
		background: #b7886c;
		color: #FFFFFF;
		border-color: #cdac98 !important;
	}

	.knowledgebaseitem1 .mr {
		margin-right: 0.5rem;
	}

	.knowledgebaseitem1 .pagediv {
		height: 3.5rem;
		line-height: 3.5rem;
		text-align: right;
	}

	.knowledgebaseitem1 .pagenum {
		width: 2rem;
	}

	.knowledgebaseitem1 .pagebtn {
		width: 4.5rem;
	}

	.knowledgebaseitem1 .pagebtn,
	.knowledgebaseitem1 .pagenum {
		background: #FFFFFF;
		color: #b7886c;
		font-size: 0.9rem;
		text-decoration: none;
		display: inline-block;
		height: 2rem;
		position: relative;
		margin-top: 0.75rem;
	}

	.knowledgebaseitem1 .pagebtn span,
	.knowledgebaseitem1 .pagenum span {
		border: 1px solid #b7886c;
		display: block;
		position: absolute;
		left: 2px;
		right: 2px;
		bottom: 2px;
		top: 2px;
		line-height: calc(2rem - 6px);
		text-align: center;
	}

	.knowledgebaseitem1 .pagediv_left {
		color: #5f3519;
		font-size: 1.142857rem;
		font-weight: bold;
		float: left;
	}

	.knowledgebaseitem1 .toptitle {
		height: 2.5rem;
		background: #FFFFFF;
		display: flex;
		line-height: 2.5rem;
		color: #783d1a;
		font-weight: bold;
		font-size: 1.142857rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}

	.knowledgebaseitem1 .toptitle img {
		width: 1.3rem;
		height: 1.3rem;
		display: block;
		float: left;
		margin-top: 0.6rem;
		margin-bottom: 0.6rem;
		margin-right: 0.6rem;
	}

	.knowledgebaseitem1 .toptitleleft {
		width: 65%;
		height: 2.5rem;
	}

	.knowledgebaseitem1 .toptitleright {
		width: 35%;
		height: 2.5rem;
		text-align: center;
		display: flex;
		justify-content: center;
	}

	.knowledgebaseitem1 .zskbox {
		background: #faf7f3;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		margin-bottom: 1rem;
	}

	.knowledgebaseitem1 .zskbox a {
		text-decoration: none;
		color: #000000;
	}

	.knowledgebaseitem1 .zskitem {
		height: 4.5rem;
		line-height: 4.5rem;
		display: flex;
		border-bottom: 1px solid #c8ae9d;
		font-size: 1.142857rem;
	}

	.knowledgebaseitem1 .zskitem:hover {
		background: #e4e4e4;
	}

	.knowledgebaseitem1 .zskitem:last-child {
		border: none;
	}

	.knowledgebaseitem1 .zskitemleft {
		width: 65%;
	}

	.knowledgebaseitem1 .zskitemleft span {
		color: #a72958;
	}

	.knowledgebaseitem1 .zskitemright {
		width: 35%;
		text-align: center;
	}

	.knowledgebaseitem1 .center {
		clip-path: none;
		text-align: center;
	}
</style>
